export const MobileMenu = () => {
  return (
    <div className="mobile-menu-area">
      <div className="container clearfix">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="mobile-menu">
              <nav id="dropdown">
                <ul>
                  <li>
                    <a href="index.html">Inicio</a>
                  </li>

                  <li>
                    <a href="">Registro</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
